import { render } from "./BaccaratBetLimit.vue?vue&type=template&id=5bb199dc"
import script from "./BaccaratBetLimit.vue?vue&type=script&lang=js"
export * from "./BaccaratBetLimit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__